export const REGISTER_REQUEST = "registerReducer/REGISTER_REQUEST";
export const REGISTER_SUCCESS = "registerReducer/REGISTER_SUCCESS";
export const REGISTER_FAILED = "registerReducer/REGISTER_FAILED";
export const REGISTER_RESET = "registerReducer/REGISTER_RESET";